import React from "react";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { ButtonIcon } from "../../Buttons/ButtonIcon/ButtonIcon";

import "./NormalizersActions.scss";
import FileCopyIcon from "@material-ui/icons/FileCopy";

export const NormalizersActions = ({
    index,
    onEdit,
    onDelete,
    onCopyDataNormalizer
}) => (
    <div className={"data-normalizers-actions"}>
        <ButtonIcon
            title={"Copy"}
            onClick={() => onCopyDataNormalizer(index)}
        >
            <FileCopyIcon />
        </ButtonIcon>

        <ButtonIcon
            onClick={() => onEdit(index)}
            title={"Edit"}
        >
            <EditIcon/>
        </ButtonIcon>

        <ButtonIcon
            warning
            onClick={() => onDelete(index)}
            title={"Delete"}
        >
            <DeleteIcon/>
        </ButtonIcon>
    </div>
);
